import { useAuth } from 'src/auth/AuthContext';

export default function useLocalUser() {
  const { user, loading } = useAuth();

  return {
    localUser: user,
    loading
  };
}
